<template>
  <div>
    <div v-if="loading">loading...</div>
    <div v-if="!loading" class="table-responsive">
      <table class="table table-sm text-nowrap">
        <tr>
          <th>作成日時</th>
          <th>UserID</th>
          <th>Type</th>
          <th>Pid</th>
          <th>redirectId</th>
          <th>Source</th>
        </tr>
        <tr v-for="(log, index) in this.logs" :key="index">
          <td>{{ log.createdAt }}</td>
          <td>{{ log.uid }}</td>
          <td>{{ log.type }}</td>
          <td>{{ log.pid }}</td>
          <td>{{ log.redirectId }}</td>
          <td>{{ log.source }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import master from '@/constants/MasterEnum'
import firebase from 'firebase'
import utils from '@/utils/Utils'

export default {
  name : "UserLogInfo",
  mixins: [
    utils,
    master
  ],
  data () {
    return {
      loading : false,
      db : firebase.firestore(),
      logs : [],
     // copy:[],
    }
  },
  props : {
    firstDate : {
      type : Date,
      required : true,
    },
    lastDate : {
      type : Date,
      required : true,
    },
    pid:{
      type:String,
      required:false,
    },
    redirectId:{
      type:String,
      required:false,
    },
/*     bus:{
      type:Object,
      required:true,
    } */
  },
  created: function() {
    this.loading = true;
    let query=this.db.collection("usersLog");
     if(this.pid!=='')
    {
      query=query.where('pid','==',this.pid);
    }
    if(this.redirectId!=='')
    {
      query=query.where('redirectId','==',this.redirectId);
    } 
    query.orderBy('created_at', 'desc')
      .startAt(this.lastDate)
      .endAt(this.firstDate)
      .get()
      .then((query) => {
        query.forEach((doc) => {
          if (doc.exists) {
            var data = doc.data();
            this.logs.push({
              id : doc.id,
              createdAt : this.formatDateTime((data.created_at).toDate()),
              source : data.source,
              type : data.type,
              uid : data.uid,
              pid : data.pid,
              redirectId : data.redirectId,
            })
          }
        });
      })
      .then(() => {
        this.loading = false;
       // this.copy=this.logs;
        this.$emit('bind-event' , this.logs , this.tsvFormat.logInfo.fileName , this.tsvFormat.logInfo.labels)
      });
/*       this.bus.$on('search',((data)=>{
        this.pid=data.pid;
        this.redirectId=data.redirectId; */

        // Scalable query version
/*         var query = this.db.collection('usersLog')
        this.logs=[];
        for(const [key,value] of Object.entries(data)){
          if(value!=''){
            query=query.where(key,'==',value);
          }
        }
        query.get().then((result)=>{
          result.forEach((doc)=>{
          if (doc.exists) 
          {
            var data = doc.data();
            this.logs.push({
              id : doc.id,
              createdAt : this.formatDateTime((data.created_at).toDate()),
              source : data.source,
              type : data.type,
              uid : data.uid,
              pid : data.pid,
              redirectId : data.redirectId,
            })
          }
          });
        }) */

        // simple filter version
/*         
        if(data.pid=='' && data.redirectId==''){ // reset
          this.logs=this.copy;
        }
        else if (data.pid!=='' && data.redirectId==''){
          let temp = this.copy.filter(item=>item.pid==data.pid);
          this.logs=temp;
        }
        else if (data.pid=='' && data.redirectId!==''){
          let temp = this.copy.filter(item=>item.redirectId==data.redirectId);
          this.logs=temp;
        }
        else{ 
          let temp = this.copy.filter(item=>item.pid==data.pid && item.redirectId==data.redirectId);
          this.logs=temp;
        } */
      //}));
  }

}
</script>